export const INSTALL_STATE_KEY = "zappy-pwa-installed";
export const OFFICIAL_APP_ORIGIN = "https://zappyconecta.com";

const OFFICIAL_APP_HOSTS = new Set(["zappyconecta.com", "www.zappyconecta.com"]);
const DEVELOPMENT_HOSTS = new Set(["localhost", "127.0.0.1"]);

const normalizePath = (path: string) => (path.startsWith("/") ? path : `/${path}`);

export const isOfficialAppHost = (hostname: string) =>
  OFFICIAL_APP_HOSTS.has(hostname.toLowerCase());

export const isDevelopmentHost = (hostname: string) =>
  DEVELOPMENT_HOSTS.has(hostname.toLowerCase());

export const shouldForceOfficialInstallSource = (hostname: string) =>
  !isOfficialAppHost(hostname) && !isDevelopmentHost(hostname);

export const getOfficialAppUrl = (path = "/") =>
  `${OFFICIAL_APP_ORIGIN}${normalizePath(path)}`;

export const getOfficialInstallUrl = (path = "/install") =>
  getOfficialAppUrl(path);

export const getInstallUrl = (
  path = "/install",
  runtime?: { hostname?: string; origin?: string },
) => {
  const hostname = runtime?.hostname ?? (typeof window !== "undefined" ? window.location.hostname : "");
  const origin = runtime?.origin ?? (typeof window !== "undefined" ? window.location.origin : "");

  if (hostname && isDevelopmentHost(hostname) && origin) {
    return `${origin}${normalizePath(path)}`;
  }

  return getOfficialInstallUrl(path);
};

export const isRunningStandalone = () => {
  if (typeof window === "undefined") return false;

  const navigatorWithStandalone = window.navigator as Navigator & { standalone?: boolean };

  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    navigatorWithStandalone.standalone === true ||
    document.referrer.startsWith("android-app://")
  );
};